import { ObservableArray, View } from "binder"
import { ServerSideDataLoader } from "uicomponents";
import { reportType, transaction, TransactionListViewModel } from "./transactionList-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class TransactionListView extends View<TransactionListViewModel>{
    GetViewUniqueId(): string {
        return "V-105D2464-6640-44D3-8AFE-13B4034629CD"
    }
    loadHtml(): string {
        let element = require('./transactionList.html').default;
        let style = require('./transactionList.less');
        return element;
    }
    constructor() {
       super();
    }    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set reportTypes(v: ObservableArray<reportType>) { this._reportTypes = v; } public get reportTypes(): ObservableArray<reportType> { return this._reportTypes;} private _reportTypes: ObservableArray<reportType>;
    public set selectedReportType(v: reportType) { this._selectedReportType = v; } public get selectedReportType(): reportType { return this._selectedReportType;} private _selectedReportType: reportType;
    public set transactions(v: ObservableArray<transaction>) { this._transactions = v; } public get transactions(): ObservableArray<transaction> { return this._transactions;} private _transactions: ObservableArray<transaction>;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    public set from(v: moment.Moment) { this._from = v;} public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v;} public get until(): moment.Moment { return this._until;} private _until: moment.Moment;

    load(){
        this.dataContext.refresh();
    }

    updateAllTransaction(){
        this.dataContext.updateAllTransaction();
    }
}
